<ion-text fill="clear" id="terms-and-conditions-modal" class="button-inline" (click)="setOpen(true)">Términos y
  condiciones</ion-text>
<ion-modal #modalTyC [isOpen]="isModalOpen" (didDismiss)="closeModalTerms()" class="center-modal policy-modal">
  <ng-template>
    <ion-content class="ion-padding" style="background-image: none">
      <div class="enc_modal">
        <ion-button class="close-modal-button" fill="clear" (click)="modalTyC.dismiss()">
          <ion-icon size="large" name="close-outline"></ion-icon>
        </ion-button>
        <app-logo class="logo-small"></app-logo>
      </div>

      <div class="pdf-container">
        <div class="pdf-controls">
          <ion-button shape="round" fill="clear" size="small" (click)="zoomIn()">
            <ion-icon slot="icon-only" name="add-circle"></ion-icon>
          </ion-button>
          <ion-button shape="round" fill="clear" size="small" (click)="zoomOut()">
            <ion-icon slot="icon-only" name="remove-circle"></ion-icon>
          </ion-button>
        </div>
      </div>

      <div style="margin-top: 70px;">
        <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false" style="width: 100%; height: 63vh;"
          [zoom]="zoom"></pdf-viewer>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>